/**
 * UserManagement Repository
 * 사용자 관리 API 호출
 */
import { API_BASE_URL } from '../../../config/api';
import { User, UserCreate, UserUpdate } from '../models/UserManagement';

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export class UserManagementRepository {
  /**
   * 사용자 목록 조회
   */
  async getUsers(): Promise<User[]> {
    // 🧪 테스트용 데이터 (실제 API가 준비되면 교체)
    const testUsers: User[] = [
      {
        id: 'user-1',
        user_number: 'U001',
        name: '김철수',
        phone: '010-1234-5678',
        email: 'kim@example.com',
        is_active: true,
        created_at: '2024-01-15T09:00:00Z',
        updated_at: '2024-01-15T09:00:00Z',
        preferred_seats: [1, 5, 10],
      },
      {
        id: 'user-2',
        user_number: 'U002',
        name: '이영희',
        phone: '010-2345-6789',
        email: 'lee@example.com',
        is_active: true,
        created_at: '2024-01-20T14:30:00Z',
        updated_at: '2024-01-20T14:30:00Z',
        preferred_seats: [2, 7],
      },
      {
        id: 'user-3',
        user_number: 'U003',
        name: '박민수',
        phone: '010-3456-7890',
        email: '',
        is_active: false,
        created_at: '2024-02-01T11:15:00Z',
        updated_at: '2024-02-01T11:15:00Z',
        preferred_seats: [],
      },
      {
        id: 'user-4',
        user_number: 'U004',
        name: '최지은',
        phone: '010-4567-8901',
        email: 'choi@example.com',
        is_active: true,
        created_at: '2024-02-05T16:45:00Z',
        updated_at: '2024-02-05T16:45:00Z',
        preferred_seats: [15, 16, 17],
      },
      {
        id: 'user-5',
        user_number: 'U005',
        name: '정현우',
        phone: '010-5678-9012',
        email: 'jung@example.com',
        is_active: true,
        created_at: '2024-02-10T08:20:00Z',
        updated_at: '2024-02-10T08:20:00Z',
        preferred_seats: [3, 4],
      },
    ];

    return testUsers;

    // 실제 API 호출 코드 (추후 활성화)
    // const response = await fetch(`${API_BASE_URL}/api/v1/users`, {
    //   headers: getAuthHeaders(),
    // });
    //
    // if (!response.ok) {
    //   throw new Error('사용자 목록을 불러올 수 없습니다');
    // }
    //
    // return await response.json();
  }

  /**
   * 사용자 생성
   */
  async createUser(userData: UserCreate): Promise<User> {
    const response = await fetch(`${API_BASE_URL}/api/v1/users`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error('사용자 생성에 실패했습니다');
    }

    return await response.json();
  }

  /**
   * 사용자 수정
   */
  async updateUser(userId: string, userData: UserUpdate): Promise<User> {
    const response = await fetch(`${API_BASE_URL}/api/v1/users/${userId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error('사용자 수정에 실패했습니다');
    }

    return await response.json();
  }

  /**
   * 사용자 삭제
   */
  async deleteUser(userId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/api/v1/users/${userId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('사용자 삭제에 실패했습니다');
    }
  }

  /**
   * 사용자 활성화/비활성화
   */
  async toggleUserActive(userId: string, isActive: boolean): Promise<User> {
    const response = await fetch(`${API_BASE_URL}/api/v1/users/${userId}/toggle-active`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ is_active: isActive }),
    });

    if (!response.ok) {
      throw new Error('사용자 상태 변경에 실패했습니다');
    }

    return await response.json();
  }
}

export const userManagementRepository = new UserManagementRepository();
